import React from 'react';

export const renderCreateModifiedDates = (dateString: string) => {
  if (dateString === 'Create Date should be Null' || dateString === 'Create Date should be Present') {
    return dateString;
  }

  const normalizeDisplay = (value: string) => {
    const trimmed = value.trim();
    if (!trimmed) return 'null';
    return trimmed;
  };

  const renderRow = (label: string, documentValue: string) => (
    <div className="d-flex justify-content-start">
      <div style={{ minWidth: '90px' }}>{label}</div>
      <div style={{ minWidth: '220px' }}>{normalizeDisplay(documentValue)}</div>
    </div>
  );

  const renderCreateRow = (value: string) => {
    return renderRow('Create Date:', value);
  };

  const renderModifiedRow = (value: string) => {
    return renderRow('Modified Date:', value);
  };

  const hasCreate = /Create Date:/i.test(dateString);
  const hasModified = /Modified Date:/i.test(dateString);

  if (hasCreate && hasModified) {
    const [beforeModified, afterModified] = dateString.split(/Modified Date:/i);
    const createdVal = (beforeModified.split(/Create Date:/i).pop() || '');
    const modifiedVal = (afterModified || '');
    return (
      <>
        {renderCreateRow(createdVal)}
        {renderModifiedRow(modifiedVal)}
      </>
    );
  }

  const createdMatch = dateString.match(/Create Date:\s*([^\r\n]*)/i);
  const modifiedMatch = dateString.match(/Modified Date:\s*([^\r\n]*)/i);

  if (createdMatch || modifiedMatch) {
    return (
      <>
        {createdMatch && renderCreateRow(createdMatch[1] || '')}
        {modifiedMatch && renderModifiedRow(modifiedMatch[1] || '')}
      </>
    );
  }

  return dateString;
};
